(function () {
  'use strict';

  // ---------------------------------------------------------------------
  // Close button: normally handled by script.js ($('a.close-cart.close')),
  // but that only works once script.js has loaded and bound its handler.
  // Since the drawer can now open before other scripts finish loading (see
  // openCartDrawer below), it needs to be closeable the same way -- bound
  // immediately here, independent of jQuery/script.js load timing.
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.close-cart');
    if (!closeBtn || !closeBtn.closest('#dropdown-cart')) return;

    document.querySelectorAll('#dropdown-cart').forEach(function (drawer) {
      drawer.classList.remove('menu-open');
    });
    document.documentElement.classList.remove('cart-show');
  });

  // ---------------------------------------------------------------------
  // PDP sticky "Add to Bag" button: normally forwarded to the real Add to
  // Cart button by luxwatches.js (a large, late-loading file). If that
  // hasn't loaded yet when clicked, there's no handler to intercept the
  // click, so the browser falls back to actually submitting the sticky
  // form -- navigating to the full /cart page instead of opening the
  // drawer. Handled directly and immediately here instead, independent of
  // luxwatches.js's load timing. stopImmediatePropagation() is used so
  // that if luxwatches.js's own handler binds later, it won't ALSO fire
  // for this same click and add the product a second time.
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sticky-btn-addToCart]');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (btn.disabled) return;

    var stickyForm = btn.closest('form');
    var idField = stickyForm ? stickyForm.querySelector('[name="id"]') : null;
    var variantId = idField ? idField.value : null;

    if (!variantId) return;

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Could not add item to cart');
          });
        }
        return response.json();
      })
      .then(function () {
        updateCartCount();

        var refresh = Promise.resolve();
        if (window.luxwatches && typeof window.luxwatches.refreshDropdownCart === 'function') {
          refresh = window.luxwatches.refreshDropdownCart();
        } else if (window.luxwatches && typeof window.luxwatches.updateDropdownCart === 'function') {
          refresh = Promise.resolve(window.luxwatches.updateDropdownCart());
        }

        return Promise.resolve(refresh).then(openCartDrawer);
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);
        alert(error.message || 'Sorry, we could not add that item to your cart.');
      })
      .finally(function () {
        btn.disabled = false;
      });
  });

  // ---------------------------------------------------------------------
  // Delegated click handler: bound ONCE on document, so it works for every
  // .add-to-cart-btn on the page -- including ones added later by infinite
  // scroll / ajax pagination (Ajaxinate) or a re-rendered section. No need
  // to wait for DOMContentLoaded or re-scan the DOM.
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.add-to-cart-btn');
    if (!button) return;

    if (button.disabled) return; // guard against double-clicks mid-request

    var variantId = button.getAttribute('data-variant-id');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Could not add item to cart');
          });
        }
        return response.json();
      })
      .then(function () {
        updateCartCount();

        // Refresh the drawer's contents FIRST, then open it. Prefer
        // refreshDropdownCart (cart-drawer-render.js) since it re-renders
        // via the real Liquid section (discounts/offer text included);
        // fall back to updateDropdownCart if that's not available.
        var refresh = Promise.resolve();
        if (window.luxwatches && typeof window.luxwatches.refreshDropdownCart === 'function') {
          refresh = window.luxwatches.refreshDropdownCart();
        } else if (window.luxwatches && typeof window.luxwatches.updateDropdownCart === 'function') {
          refresh = Promise.resolve(window.luxwatches.updateDropdownCart());
        }

        return Promise.resolve(refresh).then(openCartDrawer);
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);
        alert(error.message || 'Sorry, we could not add that item to your cart.');
      })
      .finally(function () {
        button.disabled = false;
      });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        document.querySelectorAll('.cstm_cartCount').forEach(function (el) {
          el.textContent = data.item_count;
        });
      })
      .catch(function (error) { console.error('Error updating cart count:', error); });
  }

  function openCartDrawer() {
    // Don't rely on simulating a click on the real cart-icon toggle --
    // that only works if luxwatches.js (a much larger file, loaded later
    // in the footer) has ALREADY finished loading and bound its own click
    // handler. If someone clicks "Add to Bag" while the page is still
    // loading, that click does nothing (no listener bound yet), and the
    // product gets added but the drawer stays shut. This sets the actual
    // CSS state that makes the drawer visible directly instead, so it
    // works no matter what else has or hasn't finished loading:
    //   - "menu-open" on #dropdown-cart -> desktop visibility
    //   - "cart-show" on <html>         -> mobile visibility
    // (confirmed from the theme's CSS -- these are the two rules that
    // actually control whether the drawer is shown, independent of
    // luxwatches.js's own toggle logic)
    document.querySelectorAll('#dropdown-cart').forEach(function (drawer) {
      drawer.classList.add('menu-open');
    });
    document.documentElement.classList.add('cart-show');

    // Best-effort: replicate the free-shipping message refresh that
    // normally happens on open, if luxwatches.js is already loaded.
    // Harmless no-op if it isn't.
    if (window.luxwatches && typeof window.luxwatches.initFreeShippingMessage === 'function') {
      window.luxwatches.initFreeShippingMessage();
    }
  }

  // ---------------------------------------------------------------------
  // Discount-text threshold check (unrelated to add-to-cart). Re-checked
  // whenever the drawer re-renders, not only once at initial load.
  // ---------------------------------------------------------------------
  function checkDiscountThreshold() {
    var totalEl = document.querySelector('.custm_total');
    if (!totalEl) return;
    var formattedTotal = parseInt(totalEl.innerHTML.replace(/[^\d]/g, ''), 10);
    var discountEl = document.querySelector('.discount_txt');
    if (discountEl) {
      discountEl.classList.toggle('cstm_txt_cart', formattedTotal >= 5000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkDiscountThreshold);
  } else {
    checkDiscountThreshold();
  }
  document.addEventListener('cart:drawer:updated', checkDiscountThreshold);
})();
